<template>
<el-container style="height: 100%;">
  <el-aside width="360px" style="background-color: #e4e6ecd6;position: relative;">
    <div class="headTitle">
      <div class="headItem" :class="{'is-active': index === activeIndex}" v-for="(item, index) in tabs" :key="index" @click="activeTabs(item)">{{item}}
      </div>
    </div>
    <div class="box" style="position: absolute;left: 0;
right: 0;bottom: 0;top: 37px;overflow-y: auto">
      <div class="leftCon">
        <div class="formWrapper">
          <el-form :model="diagnoseForm"
                   size="mini"
                   label-width="68px"
                   label-position="left"
          >
            <el-form-item label="影像类型" prop="type">
              <el-select v-model="imageTypeFilter" multiple placeholder="请选择影像类型" style="width: 236px">
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>



            <el-form-item label="姓名" prop="name">
              <el-input v-model="diagnoseForm.name" style="width: 236px;" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group
                v-model="diagnoseForm.gender"
                size="mini"
                style="height:28px;"
              >
                <el-radio-button label="男"></el-radio-button>
                <el-radio-button label="女"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form :model="diagnoseForm"
                     size="mini"
                     :inline="true"
                     style="width:100%;"
            >
              <span class="title"
                    style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">
                    年龄
              </span>
              <el-form-item style="width:35%;">
                <el-input v-model="age_start" placeholder="从" maxlength="3"
                          @input="ageChange('age_start')"></el-input>
              </el-form-item>
              <el-form-item style="width:35%;margin-right: 0;">
                <el-input v-model="age_end" placeholder="到" maxlength="3"
                          @input="ageChange('age_end')"></el-input>
              </el-form-item>
            </el-form>

              <el-form-item label="主诉" prop="complaint">
                <el-input v-model="diagnoseForm.complaint" placeholder="支持模糊搜索"   style="width: 236px;"
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="诊断结果" prop="diagnosis">
                <el-autocomplete style="width: 236px;"
                                  class="popInput"
                                  v-model="diagnoseForm.doctor_conclusion"
                                  :fetch-suggestions="queryDisease"
                                  placeholder="选择诊断结果（支持模糊搜索）"
                                  :trigger-on-focus="false"
                                  @select="selectedDisease"
                                  @input="inputVal"
                                  size="small"
                ></el-autocomplete>
              </el-form-item>

              <el-form-item label="临床诊断" prop="initial_conclusion">
                <el-input v-model="diagnoseForm.initial_conclusion" placeholder="支持模糊搜索临床诊断信息"   style="width: 236px;"
                          type="textarea"></el-input>
              </el-form-item>
            
            <el-form-item label="检查时间">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form :model="diagnoseForm"
                     size="mini"
                     :inline="true"
            >
              <span class="title"
                style="display:inline-block;font-size:14px;color: #606266;width: 68px;height: 28px;line-height: 28px">
                检查部位
              </span>
              <el-form-item style="width:35%;">
                <el-select
                  v-model="position_overview"
                  placeholder="大体部位"
                  size="mini"
                  @change="choosedOverview"
                >
                  <el-option
                    v-for="(item, key) in position"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width:35%;margin-right: 0;">
                <el-select
                  v-model="position_detail"
                  placeholder="具体部位"
                  size="mini"
                  no-data-text="请先选大体部位"
                >
                  <el-option
                    v-for="item in position2"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-form-item label="收藏">
              <el-radio-group
                v-model="taggedFilter"
                size="mini"
                style="height:28px;"
              >
                <el-radio-button label="是"></el-radio-button>
                <el-radio-button label="否"></el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="备注" prop="doctor_report">
              <el-input v-model="diagnoseForm.doctor_report" style="width: 236px;" placeholder="支持模糊搜索备注信息"></el-input>
            </el-form-item>

            <el-form-item label="申请医生"   prop="applicant">
              <!-- <el-input v-model="diagnoseForm.applicant" style="width:190px;" v-if="!applyDoctorsExist"></el-input> -->
              <el-input
                v-model="diagnoseForm.applicant"
                placeholder="请输入申请医生"
                style="width: 236px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请单位"  prop="applicant_unit">
              <el-select v-model="diagnoseForm.applicant_unit" placeholder="请选择申请单位" style="width: 236px;">
                <el-option
                  v-for="item in applyUnitData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 此处的“检查医生”其背后数据为review_doctor，也即出报告的医生 -->
            <el-form-item label="检查医生" prop="review_doctor">
              <el-input
                v-model="diagnoseForm.review_doctor"
                placeholder="请输入检查医生"
                style="width: 236px;"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 31px;">
            <div class="moreWrapper" v-show="showMore" style="width: 94%">
              <!--<div class="moreBtn iconfont" @click="showMoreEvent">&#xe7fe;</div>-->
              <div class="show-more-text"  @click="showMoreEvent">更多</div>
              <div class="iconfont show-more-btn" @click="showMoreEvent">&#xe7fe;</div>
            </div>
            </el-form-item>
            <el-form-item v-show="!showMore" label="检查单位" prop="unit">
              <el-select v-model="diagnoseForm.unit" placeholder="请选择检查单位" style="width: 236px;">
                <el-option
                        v-for="item in applyUnitData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="检查编号" v-show="!showMore" prop="id_in_hospital">
              <el-input v-model="diagnoseForm.id_in_hospital" style="width: 236px;"
                        placeholder="请输入检查编号"></el-input>
            </el-form-item>

            <!--显示更多时候所显示的内容-->
            <el-form-item label="民族" v-show="!showMore" >
              <el-select
                v-model="diagnoseForm.race"
                placeholder="民族"
                size="mini"
                style="width:80px;"
              >
                <el-option
                  v-for="item in races"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="肤色" v-show="!showMore"  prop="name">
              <el-select
                v-model="diagnoseForm.skin_color"
                placeholder="选择肤色"
                size="mini"
                style="width:236px"
              >
                <el-option
                  v-for="item in skinOps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电话" v-show="!showMore" prop="phone">
              <el-input v-model="diagnoseForm.phone" style="width: 236px;"
                        placeholder="请输入完整的电话号" maxlength="11" @input="stipulateNumber('phone')"></el-input>
            </el-form-item>
            <el-form-item label="地址" v-show="!showMore" prop="address">
              <el-input v-model="diagnoseForm.address" style="width: 236px;"
                        placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item label="身份证" v-show="!showMore" prop="idCardNumber" >
              <el-input
                v-model="diagnoseForm.id_card_number"
                type
                placeholder="请输入完整的身份证号"
                style="width:236px;"
                maxlength="18"
                @input="stipulateNumber('id_card_number')"
              ></el-input>
            </el-form-item>
            <el-form-item label="籍贯" v-show="!showMore" prop="nativePlace" >
              <el-input
                v-model="diagnoseForm.native_place"
                type
                style="width:236px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="国别" v-show="!showMore" prop="country" >
              <el-input
                v-model="diagnoseForm.country"
                type
                style="width:236px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="职业" v-show="!showMore" prop="profession" >
              <el-input
                v-model="diagnoseForm.profession"
                type
                style="width:236px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮件" v-show="!showMore" prop="email" >
              <el-input
                v-model="diagnoseForm.email"
                type
                style="width:236px;"
              ></el-input>
            </el-form-item>

            <!-- <el-form-item label="主诉">
                <el-input v-model="diagnoseForm.complaint" style="width: 85%;"></el-input>
            </el-form-item> -->
            <el-form-item label="既往史" v-show="!showMore">
              <el-input v-model="diagnoseForm.disease_history_before"  placeholder="支持模糊搜索"  style="width: 236px;"
                        type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="现病史" v-show="!showMore">
              <el-input v-model="diagnoseForm.disease_history_present"  placeholder="支持模糊搜索"   style="width: 236px;"
                        type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="实验室" v-show="!showMore">
              <el-input v-model="diagnoseForm.lab" style="width: 236px;"  placeholder="支持模糊搜索"   type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="家族史" v-show="!showMore">
              <el-input v-model="diagnoseForm.disease_history_family"  placeholder="支持模糊搜索"   style="width: 236px;"
                        type="textarea"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 31px;" v-show="!showMore">
              <div class="moreWrapper" >
                <!--<div class="moreBtn iconfont" @click="closeMoreEvent">&#xe7d3;</div>-->
                <div class="show-more-text"  @click="closeMoreEvent">收起</div>
                <div class="iconfont show-more-btn" @click="closeMoreEvent">&#xe7d3;</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-aside>
  <el-container>
    <div class="right-content-wrap">
      <div class="right-content-wrap-main">
        <el-container style="height: 96%;padding: 0px">
          <el-main style="padding: 0;">
            <div class="rightCon">
              <div class="filterCon">
                <div class="filterItem" v-for="(item, key) in diagnoseSelect" :key="key" v-show="item.val">
                  <div>{{item.key}}：{{item.val}}</div>
                  <div class="close-btn iconfont" @click="closeFilter(key)">&#xe634;</div>
                </div>
              </div>
              <div class="filter-count"   v-show="activeIndex === 0&&differentContent.diagExport">
                <div class="download-btn-wrap" v-acl="['export_hostory']">
                  <div class="download-btn" @click="downloadAllFolder">导出全部</div>
                  <div class="download-btn" @click="downloadFolder">导出</div>
                </div>
              </div>
              <div class="filter-count"  v-show="activeIndex === 1">
                <div class="download-btn-wrap" v-acl="['export_hostory']">
                  <div class="download-btn" @click="downloadAll">导出全部</div>
                  <div class="download-btn" @click="downloadSelected">导出</div>
                </div>
              </div>
              <!--存放诊断记录的容器-->
              <div class="diagnoses-con" v-show="activeIndex === 0">
                <div class="moreItem">
                  <div v-for="(innerItem, index) in moreResultArr" :key="index" class="check-box"
                       @click="getInfo(innerItem.patient.id, innerItem.id)"
                       v-if="innerItem.images">
                    <div class="img-box">
                      <img :src="imageSrcPrefixThumbnails+innerItem.images[0].path" alt="" class="check-img"
                           v-if="innerItem.images[0]">
                    </div>
                    <div class="check-info">
                      <p style="display: flex;justify-content: space-between">
                            <span style="flex: 1;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                              <span>患者姓名: </span>
                              <span>{{innerItem.patient.name}}</span></span>
                      </p>
                      <p class="ellipsis">检查类型: <span v-if="innerItem.images.length">{{innerItem.images[0].type |
                            filtersType}}</span></p>
                      <p>检查时间: <span>{{innerItem.time | filtersMoment}}</span></p>
                      <p style="display: flex;">检查部位: <span class="ellipsisSpan ellipsis">{{innerItem.position_detail_list}}</span></p>
                      <div style="display: flex;align-items: flex-end;justify-content: space-between">
                        <p class="ellipsisP">检查结果: <span class="ellipsis ellipsisSpan">{{innerItem.doctor_conclusion |
                              filtersConclusion}}</span></p>
                        <div
                          class="iconfont modify-btn"
                          v-acl="['diagnoses_image']"
                          style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold;cursor: pointer"
                          title="编辑诊断"
                          @click.stop="modifyDiagnosis(innerItem)"
                          v-if="isShowModifyDiagnosisBtn(innerItem.time) && innerItem.isedit === 1"
                        >&#xe630e;</div>
                        <div
                          class="iconfont"
                          v-acl="['diagnoses_image']"
                          style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                          title="不可编辑"
                          v-else
                          @click.stop
                        >&#xe630e;</div>
                      </div>
                    </div>
                    <span @click.stop="selectedM(index)" class="iconfontRFather">
                            <span
                              v-if="innerItem.select"
                              id="iconfontR"
                              class="iconfont"
                            >&#xe642;</span>
                          </span>
                  </div>
                </div>
              </div>
              <div class="diagnoses-con2" v-show="activeIndex === 1">
                <div class="content">
                  <div class="moreItem">
                    <div class="images-item" v-for="(item, index) in moreImageArr" :key="index"
                         @click.stop="showPic(item)">
                      <img ref="image" class="image"
                           :src="imageSrcPrefixThumbnails+item.path" alt="">
                      <div class="download-btn-box" v-acl="['export_hostory']">
                        <div class="download-btn botton iconfont" @click.stop="downloadImage(item.path)">&#xe7a3;
                        </div>
                        <div class="selected-btn botton" @click.stop="selected(index)">
                          <span class="iconfont" v-show="item.select">&#xe642;</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
        <div class="pagination" >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageNumber"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
   
  <!--    <div class="pagination" v-show="activeIndex === 0">
        <el-button type="primary" :disabled="diagnosePrevDisabled" @click="diagnosePrev">上一页
        </el-button>
        <div class="current-page">{{diagnoseCurrentPage}}</div>
        <el-button type="primary" :disabled="diagnoseNextDisabled" @click="diagnoseNext">下一页
        </el-button>
      </div>
      <div class="pagination" v-show="activeIndex === 1">
        <el-button type="primary" :disabled="imagesPrevDisabled" @click="imagesPrev">上一页
        </el-button>
        <div class="current-page">{{imagesCurrentPage}}</div>
        <el-button type="primary" :disabled="imagesNextDisabled" @click="imagesNext">下一页
        </el-button>
      </div>-->
    </div>
  </el-container>
  <el-dialog
    :visible.sync="showLargeImage"
    center
    custom-class="similarDialog showBigImage_dialog_1"
    modal
    top="0"
    :fullscreen="true"
  >
    <div class="bigImage">
      <Lookimage :largeImgage="largeImgage"></Lookimage>
    </div>
  </el-dialog>
</el-container>


</template>
<script>
  
  // 图片下载
  const downloadIamge = (src, name) => {
    const image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
     /* const url = canvas.toDataURL('image/jpeg',1.0);
      
      var strDataURI = url.substr(22, url.length);
      // 生成一个a元素
      const a = document.createElement('a');
      // 创建一个单击事件
      const event = new MouseEvent('click');
      // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
      a.download = name || '图片';
      // 将生成的URL设置为a.href属性
      a.href = url;
      // 触发a的单击事件
      a.dispatchEvent(event)*/
  
      const fileName = name || '图片';
      canvas.toBlob( (blob)=> {
        const eleLink = document.createElement('a');
        eleLink.download = fileName;
        eleLink.style.display = 'none';
        // 字符内容转变成blob地址
        eleLink.href = URL.createObjectURL(blob);
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
      },'image/png',1);
     
    };
    image.src = src;
  };
  // import axios from 'axios';
  // import api from '../api';
  import csrftoken from '../getToken';
  import moment from '../../node_modules/moment/src/moment.js';
  import raceJson from "../race.js";
  import gql from 'graphql-tag';
  import PatientDiagnoseRecord from './PatientDiagnoseRecord.vue';
  import axios from 'axios';
  import api from '../api';
  import Lookimage from './LookBigImage.vue';
  import popMixins from "../utils/popMixins.js";
  import controllerDuration from "../utils/controllerDuration.js";
  import DiagnoseRecord from "./DiagnoseRecord";
  let template = {};
  let that;
  
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.errorCon = '请先进行智能搜图!!';
    differentContent.diagExport = true;
  } else {
    differentContent.diagExport = false;
    
  }
  export default {
    name: 'diagnoseImageManage',
    mixins:[popMixins, controllerDuration],
    data() {
      return {
        differentContent,
        imageResult: {
          imageSrc: '',
        },
        dialogImage: false,
        // // 详情切换
        // showDetails: false,
        // 是否显示影像大图
        isShowPic: true,
        // 详情页数据
        patientinfo: {},
        allDisease: [],
        diagnoseinfo: [],
        // 请求图片前缀
        imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
        imageSrcPrefix: api.imageSrcPrefix,
        // 诊断记录的列表
        moreResultArr: [],
        moreImageArr: [],
        // tabs
        tabs: ["就诊记录", "影像"],
        // show more
        showMore: true,
        skinOps: raceJson.skinOpn,
        position: raceJson.position.noDistinguish,
        position2: [],
        knowledge: [],
        knowledge2: [],
        races: raceJson.raceObj,
        applyUnitData: raceJson.applyUint,
        options3: [
          {
            label: '大体图/伍德灯',
            value: '1',
          },
          {
            label: '浸润皮肤镜图',
            value: '2',
          },
          {
            label: '偏振光皮肤镜图',
            value: '4',
          },
          {
            label: '皮肤CT',
            value: '8',
          },
          {
            label: '皮肤B超',
            value: '16',
          },
          {
            label: '皮肤病理',
            value: '32',
          },
        ],
        // 右侧筛选显示数据
        diagnoseSelect: {},
        diagnoseSelectTransfer: {
          image_type_flag: '检查类型',
          applicant: '申请医生',
          applicant_unit: '申请单位',
          review_doctor: '审核医生',
          unit: '检查单位',
          id_in_hospital: '检查编号',
          initial_conclusion: '临床诊断',
          name: '姓名',
          gender: '性别',
          skin_color: '肤色',
          phone: '电话',
          address: '地址',
          position: '检查部位',
          id_card_number: '身份证',
          native_place: '籍贯',
          country: '国别',
          profession: '职业',
          email: '电子邮件',
          complaint: '主诉',
          disease_history_before: '既往史',
          disease_history_present: '现病史',
          disease_history_family: '家族史',
          lab: '实验室',
          race: '民族',
          doctor_conclusion:'诊断',
          doctor_report:'备注'
        },
        imageTypeFilter: [],
        doctor_conclusionName:'',
        diagnoseForm: {
          doctor_report:'',
          image_type_flag: '',
          position: '',
          doctor_conclusion: '',
          applicant: '',
          applicant_unit: '',
          review_doctor: '',
          unit: '',
          id_in_hospital: '',
          initial_conclusion: '',
          name: '',
          gender: '',
          age_start: '',
          age_end: '',
          skin_color: '',
          phone: '',
          address: '',
          time_start: '',
          time_end: '',
          tagged: '',
          id_card_number: '',
          native_place: '',
          country: '',
          profession: '',
          email: '',
          complaint: '',
          disease_history_before: '',
          disease_history_present: '',
          disease_history_family: '',
          lab: '',
          race: '',
        },
        dateRange: "",
        position_overview: '',
        position_detail: '',
        taggedFilter: '',
        age_start: '',
        age_end: '',
        // 大体位置的索引
        overviewIndex: 0,
        imgForm: {},
        activeIndex: 0,
        images: [],
        showInfo: false,
        patientId: '',
        diagnosisId: '',
        date: '',
        result: [],
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        },
        allNum: 15,
        sId: '',
        sName: '',
        sAge: '',
        startAge: '',
        endAge: '',
        sGender: '',
        sDate: '',
        imagesType: ['大体图/伍德灯', '浸润皮肤镜图', '偏振光皮肤镜图', '皮肤CT', '皮肤B超', '皮肤病理'],
        timer: '',
        pageNumber:1,
        // 显示大图参数
        picDetails: {
          position: '',
          type: '',
          time: '',
          size: '',
        },
        imgSwitch: false,
        // graphql请求的参数
        requestParams:
          `
          count
          data{
              id
              isedit
              doctor_conclusion
              time
              image_type_flag
              position_detail_list
              patient{
                      id
                      name
                     }
              images{
                    id
                    path
                    type
                    print_time
                    }
          }`,
        pageSize: 20,
        pageTotal:0,
        // 查看大图地址
        largeImgage: '',
        showLargeImage: false,
        knowledgeDic: {},
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
        queryParam: '',
        isDownloadFolder: false,
        selectItemsId:[],
      };
    },
    watch: {
      'position_overview'(newVal) {
        this.position2 = this.position[newVal];
        this.diagnoseForm.position = newVal;
      },
      'position_detail'(newVal) {
        if (newVal) {
          this.diagnoseForm.position = this.position_overview + '-' + newVal;
        } else {
          this.diagnoseForm.position = this.position_overview;
        }
      },
      'age_start'(newVal) {
        if (this.age_end !== '') {
          if (newVal) {
            const ageEndS = this.age_end;
            const ageEnd = Number(ageEndS);
            const val = Number(newVal);
            if (val <= ageEnd) {
              this.diagnoseForm.age_start = newVal;
              this.diagnoseForm.age_end = ageEndS;
            } else {
              this.diagnoseForm.age_start = ageEndS;
              this.diagnoseForm.age_end = newVal;
            }
          } else {
            this.diagnoseForm.age_start = this.age_end;
            this.diagnoseForm.age_end = newVal;
          }
        } else {
          this.diagnoseForm.age_start = newVal;
          this.diagnoseForm.age_end = '';
        }
      },
      'age_end'(newVal) {
        if (this.age_start !== '') {
          if (newVal) {
            const ageStartS = this.age_start;
            const ageStart = Number(ageStartS);
            const val = Number(newVal);
            if (ageStart <= val) {
              this.diagnoseForm.age_start = ageStartS;
              this.diagnoseForm.age_end = newVal;
            } else {
              this.diagnoseForm.age_start = newVal;
              this.diagnoseForm.age_end = ageStartS;
            }
          } else {
            this.diagnoseForm.age_start = this.age_start;
            this.diagnoseForm.age_end = newVal;
          }
        } else {
          this.diagnoseForm.age_start = newVal;
          this.diagnoseForm.age_end = '';
        }
      },
      'diagnoseForm.age_start'(newVal) {
        const age_end = this.diagnoseForm.age_end;
        if (age_end) {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: newVal + '-' + age_end,
          };
        } else {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: newVal,
          };
        }
      },
      'diagnoseForm.age_end'(newVal) {
        const age_start = this.diagnoseForm.age_start;
        if (newVal) {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: (age_start ? age_start : '') + '-' + newVal,
          };
        } else {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: age_start,
          }
        }
      },
      'dateRange'(newVal) {
        if (newVal) {
          this.diagnoseForm.time_start = newVal[0];
          this.diagnoseForm.time_end = newVal[1];
          this.diagnoseSelect.time = {
            key: '检查时间',
            val: moment(newVal[0]).format("YYYY-MM-DD") + '至' +moment(newVal[1]).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseForm.time_end = '';
          this.diagnoseForm.time_start = '';
          this.diagnoseSelect.time = '';
        }
      },
      'imageTypeFilter'(newVal) {
        let count = 0;
        newVal.forEach(item => {
          count += Number(item);
        });
        count = count === 0 ? '' : count;
        this.diagnoseForm.image_type_flag = count;
        // 右侧筛选tab显示
        let value = '';
        newVal.forEach(item => {
          const type = this.imagesType;
          let index = 10;
          switch (item) {
            case "1":
              index = 0;
              break;
            case "2":
              index = 1;
              break;
            case "4":
              index = 2;
              break;
            case "8":
              index = 3;
              break;
            case "16":
              index = 4;
              break;
            case "32":
              index = 5;
              break;
          }
          value += type[index] + ' ';
        });
        this.diagnoseSelect.type = {
          key: '检查类型',
          val: value,
        };
      },
      'taggedFilter'(newVal) {
        if (newVal === '是') {
          this.diagnoseForm.tagged = 1;
          this.diagnoseSelect.tagged = {
            key: '收藏',
            val: newVal,
          };
        } else if (newVal === '否') {
          this.diagnoseForm.tagged = 0;
          this.diagnoseSelect.tagged = {
            key: '收藏',
            val: newVal,
          };
        } else if (newVal === '') {
          this.diagnoseForm.tagged = '';
        }
      },
      // 性别改变时改变部位选项
      'diagnoseForm.gender'(newVal) {
        const poOverview = this.position_overview;
        const poDetail = this.position_detail;
        if (newVal === '男') {
          this.position = raceJson.position.man;
          if (poOverview === '外阴') {
            new Promise(resolve => {
              this.position_overview = '';
              this.position_detail = '';
              resolve();
            }).then(() => {
              this.position_overview = '外阴';
            }).then(() => {
              this.diagnoseForm.gender = newVal;
            });
          }
        } else if (newVal === '女') {
          this.position = raceJson.position.woman;
          if (poOverview === '外阴') {
            new Promise(resolve => {
              this.position_overview = '';
              this.position_detail = '';
              resolve();
            }).then(() => {
              this.position_overview = '外阴';
            }).then(() => {
              this.diagnoseForm.gender = newVal;
            });
          }
        } else {
          this.position = raceJson.position.noDistinguish;
          if (poOverview === '外阴') {
            new Promise(resolve => {
              this.position_overview = '';
              this.position_detail = '';
              resolve();
            }).then(() => {
              this.position_overview = '外阴';
            }).then(() => {
              this.diagnoseForm.gender = newVal;
            });
          }
        }
      },
      // 监听筛选的数据进行请求
      'diagnoseForm': {
        async handler(newval) {
          // console.log(this.diagnoseSelect)
          clearTimeout(this.timer);
          const diagnose = newval;
          const newDiagnoseForm = this.forInDiagnoseForm(diagnose);
          let newDiagnoseSelect = this.diagnoseSelect;
          const transfer = this.diagnoseSelectTransfer;
          for (let key in diagnose) {
            if (diagnose.hasOwnProperty(key)) {
              let val = diagnose[key];
              // 右侧选项卡显示
              if (!(key === 'age_start' || key === 'age_end' || key === 'time_start' || key === 'time_end' || key ===
                'image_type_flag' || key === 'tagged'|| key === 'doctor_conclusion')) {
                newDiagnoseSelect[key] = {
                  key: transfer[key],
                  val,
                };
              }
              if (key === 'doctor_conclusion'){
                newDiagnoseSelect[key] = {
                  key: transfer[key],
                  val
                };
              }
            }
          }
          // 调用请求数据方法
          this.pageNumber = 1
          this.init()
          this.queryParam = newDiagnoseForm;
        },
        deep: true
      },
    },
    async mounted() {
      await this.queryMyTemplate();
      const response = await axios.request({
        method: 'get',
        url: api.knowledge,
      });
      const res = await axios.request({
        method: 'get',
        url: api.knowledgeDic,
      });
      this.knowledgeDic  = res.data;
      this.knowledge = response.data.children;
      if (this.$store.state.filterState.saveState) {
        // 取得vuex中保存的状态和数据
        const data = this.$store.state.filterState.data;
        const diagnoseForm = this.$store.state.filterState.diagnoseForm;
        const diagnoseSelect = this.$store.state.filterState.diagnoseSelect;
        this.diagnoseSelect = diagnoseSelect;
        this.diagnoseForm = diagnoseForm;
        this.age_start = data.age_start;
        this.age_end = data.age_end;
        this.dateRange = data.dateRange;
        this.position_overview = data.position_overview;
        this.position_detail = data.position_detail;
        this.imageTypeFilter = data.imageTypeFilter;
        this.taggedFilter = data.taggedFilter;
        this.$store.commit('clearSaveState')
      } else {
         this.init();
      }
    },
    methods: {
      selectedM(index){
        if (this.moreResultArr[index].select){
          if (this.moreResultArr[index].select === true){
            this.$set(this.moreResultArr[index], 'select',   false)
            for (let i = 0;i<this.selectItemsId.length;i++){
              let res = this.selectItemsId[i]
              if (res === this.moreResultArr[index].id){
                this.selectItemsId.splice(i,1)
              }
            }
          } else if (this.moreResultArr[index].select === false){
            this.$set(this.moreResultArr[index], 'select',  true)
            this.selectItemsId.push(this.moreResultArr[index].id)
          }
      
        } else {
          this.$set(this.moreResultArr[index], 'select', true)
          this.selectItemsId.push(this.moreResultArr[index].id)
        }
      },
      async init(){
        const newDiagnoseForm = this.forInDiagnoseForm(this.diagnoseForm);
        if (this.activeIndex === 0){
          this.pageSize = 20
          /* const response = await this.$apollo.query({
             query: gql`{
                     diagnoses(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                         ${this.requestParams}
                     }
                 }`,
             fetchPolicy: 'no-cache',
           });*/
          const response = await this.$apollo.query({
            query: gql`{
                    diagnosesPaging(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                        ${this.requestParams}
                    }
                }`,
            fetchPolicy: 'no-cache',
          });
        
         
          this.handleIsPrint(response.data.diagnosesPaging.data);
          this.moreResultArr = response.data.diagnosesPaging.data
          this.pageTotal = response.data.diagnosesPaging.count
        } else if(this.activeIndex === 1){
          this.pageSize = 35
          const res = await new Promise((resolve) => {
            const response = this.$apollo.query({
              query: gql`{
                                    imagesPaging(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                                       count
                                       data{
                                        id
                                        path
                                        position_detail
                                        upload_mark
                                        type}
                                    }
                                }`,
              fetchPolicy: 'no-cache',
            });
            resolve(response);
          })
          this.moreImageArr = res.data.imagesPaging.data;
          this.pageTotal = res.data.imagesPaging.count;
        }
    
      },
      // 是否显示编辑按钮
      isShowModifyDiagnosisBtn(date) {
        return !(moment().diff(date) >= this.countTimeModifyDiagnosisBtn);
      },
      // 编辑诊断
      async modifyDiagnosis(item) {
        // 请求相关数据
        try {
          this.$store.commit("addModifyDiagnosis", {
            diagnosisId: item.id,
          });
          this.$router.push("/home/intell");
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 导出所有文件夹
      async downloadAllFolder() {
        if (!this.isDownloadFolder) {
          this.isDownloadFolder = true;
          try {
            const res = await this.$apollo.query({
              query: gql`{
                diagnosesExport(${this.queryParam}page_number:${this.pageNumber}, page_size:${this.pageSize})
              }`,
              fetchPolicy: "no-cache",
            });
            const a = document.createElement('a'); // 创建a标签
            a.setAttribute('href', api.server + res.data.diagnosesExport);// href链接
            a.click();
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
          this.isDownloadFolder = false;
        }
      },
      // 导出文件夹
      async downloadFolder() {
        if (!this.isDownloadFolder) {
          if (this.selectItemsId.length !== 0){
            this.isDownloadFolder = true;
            try {
              const res = await this.$apollo.query({
                query: gql`query(
              $diagnosis_ids: [Int]
            ){
                diagnosesExport(diagnosis_ids:$diagnosis_ids)
              }`,
                variables:{
                  diagnosis_ids:this.selectItemsId
                },
                fetchPolicy: "no-cache",
              });
              const a = document.createElement('a'); // 创建a标签
              a.setAttribute('href', api.server + res.data.diagnosesExport);// href链接
              a.click();
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
            this.isDownloadFolder = false;
          } else {
            this.$message('没有选中信息');
          }
      
        }
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      // 处理是否打印过报告
      handleIsPrint(data) {
        for (const item of data) {
          const index = item.images.findIndex(image => image.print_time !== this.initialTime);
          item.isPrintReport = !(index > -1);
        }
        return data;
      },
      // 关闭查看大图dialog
      closeImageDetails(val) {
        this.dialogImage = val;
      },
      imgOnload(e) {
        const tag = e.target;
        if (tag.width / tag.height >= 1) {
          e.srcElement.style.height = '100%';
          e.srcElement.style.width = 'auto';
          const s = (tag.width - 84) / 2;
          e.srcElement.style.marginLeft = '-' + s + 'px';
        } else {
          e.srcElement.style.width = '100%';
          e.srcElement.style.height = 'auto';
          const s = (tag.height - 84) / 2;
          e.srcElement.style.marginLeft = 0;
          e.srcElement.style.marginTop = '-' + s + 'px';
        }
      },

      // 显示更多按钮
      showMoreEvent() {
        this.showMore = false;
      },
      closeMoreEvent() {
        this.showMore = true;
      },
  
      async activeTabs(params) {
        switch (params) {
          case "就诊记录":
            this.activeIndex = 0;
            break;
          case "影像":
            this.activeIndex = 1;
            break;
          
        }
        // 点击请求数据
        const diagnose = this.diagnoseForm;
        const newDiagnoseForm = this.forInDiagnoseForm(diagnose);
        // 调用请求数据方法
        this.pageNumber = 1
        this.init();
      },
      handleCurrentChange(val){
        this.pageNumber = val
        this.init();
      },
      choosedOverview(data) {
        this.position_detail = '';
      },
      closeInfo() {
        this.showInfo = false;
      },
      // 显示详情页
      async getInfo(id, id2) {
        try {
          // const params = {
          //   patientId: id,
          //   selectId: id2,
          //   diagnosisType: '影像',
          // };
          // console.log("In DiagnoseImageManger, getInfo(), patientId and selectId:",params);
          // if (window.sessionStorage) {
          //   this.$router.push({name: 'details'});
          //   window.sessionStorage.setItem('diagnosisParams', JSON.stringify(params));
          // } else {
          //   this.$router.push({
          //     name: 'details',
          //     params
          //   });
          // }

          //采用全局变量缓存参数
          this.$store.commit("setPatientDiagnosisRecordPara", {
              patientId: id,
              selectId: id2,
              diagnosisType: '影像'
          });
          this.$router.push({ name: "details" });

        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
        // 将筛选的状态保存到vuex中
        const filterState = {
          data: {
            age_start: this.age_start,
            age_end: this.age_end,
            dateRange: this.dateRange,
            position_overview: this.position_overview,
            position_detail: this.position_detail,
            imageTypeFilter: this.imageTypeFilter,
            taggedFilter: this.taggedFilter,
            imgDiagnose_main: this.imgDiagnose_main,
          },
          diagnoseSelect: this.diagnoseSelect,
          diagnoseForm: this.diagnoseForm,
          saveState: true,
        };
        this.$store.commit('saveFilterState', filterState);
      },
      // 单个下载
      downloadImage(path) {
        const imageName = path.split('.')[0];
        const src = this.imageSrcPrefix + path;
        downloadIamge(src, imageName);
      },
      // 导出
      downloadSelected() {
        const selectedArr = this.moreImageArr.filter(item => {
          return item.select;
        });
        if (selectedArr.length !== 0) {
          selectedArr.forEach(item => {
            const imageName = item.path.split('.')[0];
            const src = this.imageSrcPrefix + item.path;
            downloadIamge(src, imageName);
          })
        } else {
          this.$message('没有选中图片');
        }
        this.moreImageArr.forEach(item => {
          item.select = false;
        });
        this.$forceUpdate();
      },
      // 导出全部
      downloadAll() {
        const all = this.moreImageArr;
        if (all.length !== 0) {
          all.forEach(item => {
            const imageName = item.path.split('.')[0];
            const src = this.imageSrcPrefix + item.path;
            downloadIamge(src, imageName);
          })
        } else {
          this.$message('没有可下载内容');
        }
      },
      // 点击取消筛选项
      closeFilter(key) {
        if (key === 'age') {
          this.age_end = '';
          this.age_start = '';
        } else if (key === 'time') {
          this.diagnoseForm.time_end = '';
          this.diagnoseForm.time_start = '';
          this.dateRange = '';
        } else if (key === 'position') {
          this.diagnoseForm[key] = '';
          this.position_detail = '';
          this.position_overview = '';
        } else if (key === 'type') {
          this.imageTypeFilter = [];
        } else if (key === 'doctor_conclusion') {
          this.diagnoseForm.doctor_conclusion = '';
          this.doctor_conclusionName = '';
        } else if (key === 'tagged') {
          this.taggedFilter = '';
          this.diagnoseSelect.tagged = {
            key: '收藏',
            val: '',
          };
        }else {
          this.diagnoseForm[key] = '';
        }
      },
      // 显示影像大图
      showPic(data) {
        
        // 新查看大图方式传入地址
        this.largeImgage = `${this.imageSrcPrefix}${data.path}`;
        this.showLargeImage = true;
        
        
        // 旧查看大图方式传入地址
        // this.$refs.img.src = `${this.imageSrcPrefix}${data.path}`;
        // this.isShowPic = true;
        
        // dialog相关操作
        this.imageResult.imageSrc = `${this.imageSrcPrefix}${data.path}`;
        this.dialogImage = true;
        
        // 检查部位
        this.picDetails.position = data.position_detail;
        // 检查类型
        const type = this.imagesType;
        let index = 10;
        switch (data.type) {
          case 1:
            index = 0;
            break;
          case 2:
            index = 1;
            break;
          case 4:
            index = 2;
            break;
          case 8:
            index = 3;
            break;
          case 16:
            index = 4;
            break;
          case 32:
            index = 5;
            break;
        }
        this.picDetails.type = type[index];
        // 时间
        this.picDetails.time = moment(data.time).format('YYYY-MM-DD HH:mm:ss')
        
      },
      // 关闭大图
      closePic() {
        this.isShowPic = false;
        this.$refs.img.src = '';
        this.$refs.img.style.left = '0';
        this.$refs.img.style.top = '0';
      },
      selected(index) {
        this.moreImageArr[index].select = this.moreImageArr[index].select ? false : true;
        
        this.$forceUpdate();
      },
      inputVal(val){
        this.doctor_conclusionName = val;
      },
      selectedDisease(item) {
        // this.selectedDiagnose = true;
        // this.inHospitalData.diagnosis = item.value;
        this.diagnoseForm.doctor_conclusion = item.value;
        this.doctor_conclusionName = item.id;
        
      },
      filterDisease(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
          );
        };
      },
      queryDisease(queryString, cb) {
        const restaurants = this.allDisease;
        const results = queryString ? restaurants.filter(this.filterDisease(queryString)) : restaurants;
        const arr = [];
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
              if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                arr.push({
                  id: data[i].id,
                  value: data[i].name,
                })
              }
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        for (const item of results) {
          const findIndex = arr.findIndex(item1 => item.value === item1.value);
          if (findIndex === -1) {
            arr.push(item);
          }
        }
        cb(arr);
      },
      // 限制只输入数字
      stipulateNumber(value) {
        this.diagnoseForm[value] = this.diagnoseForm[value].replace(/[^\d]/g, '');
      },
      // 限制年龄只输入数字
      ageChange(value) {
        this[value] = this[value].replace(/[^\d]/g, '');
      },
      // 循环遍历取得筛选条件
      forInDiagnoseForm(diagnose) {
        let newDiagnoseForm = '';
        for (let key in diagnose) {
          if (diagnose.hasOwnProperty(key)) {
            let val = diagnose[key];
            if (key === 'doctor_conclusion'){
              val = this.doctor_conclusionName;
            }
            // 判断要穿数字还是字符串
      
            
            const bool = (key === 'image_type_flag') || (key === 'age_start') || (key === 'age_end') || (key === 'tagged');
          
            if (val !== '') {
              if (bool) {
                newDiagnoseForm += `${key}:${val},`;
              } else {
                newDiagnoseForm += `${key}:"${val.replace(/\\/g, '\\\\\\\\').replace(/"/g, '\\"')}",`;
              }
            }
          }
        }
        return newDiagnoseForm;
      },
   
      // 获取图片大小
      imgLoad(e) {
        this.picDetails.size = e.target.width + ' x ' + e.target.height;
      },
      // 图片拖拽
      imgMoseDown(e) {
        let tag = e.srcElement;
        const left = Number(tag.style.left.split('px')[0]);
        const top = Number(tag.style.top.split('px')[0]);
        this.imgSwitch = true;
        let clientX = e.clientX;
        let clientY = e.clientY;
        let count = 0;
        document.onmouseup = () => {
          this.imgSwitch = false;
        };
        document.onmousemove = (e) => {
          count++;
          if (this.imgSwitch) {
            if (count % 2 === 0) {
              const eX = e.clientX;
              const eY = e.clientY;
              const changeX = eX - clientX;
              const changeY = eY - clientY;
              tag.style.left = (left + changeX) + 'px';
              tag.style.top = (top + changeY) + 'px';
            }
          }
        };
      },
    },
    components: {
      DiagnoseRecord,
      PatientDiagnoseRecord,
      Lookimage
    },
    beforeCreate() {
      that = this;
    },
    filters: {
      filtersMoment(time) {
        return (moment(time).format('YYYY-MM-DD HH:mm:ss'));
      },
      filtersConclusion(id) {
        if (id !== '') {
          let name;
          // 从自定义模板中找病种名称
          const f = (data) => {
            for (let i = 0; i < data.length; i++) {
              if (data[i].id === id) {
                name = data[i].name;
                break;
              } else if (data[i].children && data[i].children.length) {
                f(data[i].children);
              }
            }
          };
          if (template.myTemplate) {
            f(template.myTemplate);
          }
          // 如果自定义中没有找到则在原始模板中查找
          if (!name) {
            if (that.knowledgeDic[id]) {
              name = that.knowledgeDic[id].name
            }
          }
          return name ? name : id;
        }
      },
      filtersType(index) {
        const obj = {
          0: '',
          1: '大体图/伍德灯',
          2: '浸润皮肤镜图',
          4: '偏振光皮肤镜图',
          8: '皮肤CT',
          16: '皮肤B超',
          32: '皮肤病理',
        };
        return obj[index];
      },
    },
  };
</script>
